export default "__VITE_PUBLIC_ASSET__8ce2855d__"